import styles from '../../index.module.scss'
import Utils from '@utils/utils'
import { RESOLUTION_ALIGN, BATCH_IMAGES_TYPE, RELIGHT_MODE } from '@utils/CONST'
import RefListModal from '../../../../RefListModal'
import { useRef, useState, useMemo, useEffect } from 'react'
import { Popover } from 'antd'

const ModelLeftCom = (props) => {
    const { item, setSelectedInputImg } = props
    const refListModalRef = useRef(null)

    const title = (
        <>
            <p className={styles.title}>{item?.projectName}</p>
            <p>{item?.projectType == BATCH_IMAGES_TYPE.TRYON_BATCH ? 'AI试衣' :
                item?.projectType == BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ? '换模特' :
                    item?.projectType == BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ? '换背景' :
                        item?.projectType == BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH ? '同款换色' :
                            item?.projectType == BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH ? 'AI超清' :
                                item?.projectType == BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH ? '智能详情页' :
                                    item?.projectType == BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH ? '去水印' :
                                        item?.projectType == BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH ? '搭配上身' :
                                            '商品智能堆叠'}</p>
            <p>{item?.createdTime}</p>
            <p>创建人</p>
            <p style={{ marginBottom: '24px' }}>{item?.memberName}</p>
        </>
    )

    const mode = (
        <p style={{ marginBottom: '24px' }}>{item?.attr?.mode == 'std' ? '标准模式' : '高品质模式'}</p>
    )
    const skinRefine = (
        <p>{item?.attr?.skinRefine ? '肤质高清·开启' : '肤质高清·关闭'}</p>
    )
    const customBkgMode = (
        <p>{item?.attr?.customBkgMode == 'free' ? '变化更多' : '场景不变'}</p>
    )
    const relight = (
        <p>{item?.attr?.relight > 0 ? '光影增强·开启' : '光影增强·关闭'}</p>
    )
    const relightMode = <p>{item?.attr?.relightMode === RELIGHT_MODE.REFLECTOR ? "反光板模式" : "标准模式"}</p>
    const commodityColor = (
        <p>商品颜色：{item?.attr?.commodityColor?.[0].title} 共{item?.attr?.commodityColor?.length}种</p>
    )
    const commodityCategory = (
        <p>类目：{item?.attr?.commodityCategory?.title}</p>
    )
    const commodityTemplate = (
        <p>模板：{item?.attr?.commodityTemplate?.title}</p>
    )
    const inputImg = (
        <>
            <p>{item?.projectType == BATCH_IMAGES_TYPE.TRYON_BATCH ? '商品图' :
                item?.projectType == BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH ? '主品图' :
                    item?.projectType == BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH ? '输入图' :
                        item?.projectType == BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH ? '源素材' :
                            '模特图'}</p>
            <div className={styles.inputImg}>
                {item?.projectType == BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH && <p className={styles.imgNum}>数量{item?.inputImages?.filter((i) => i.mainImage)?.[0]?.num}</p>}
                <img src={Utils.getImgThumbnail(item?.inputImages?.filter((i) => i.mainImage)?.[0]?.url)} alt="" />
            </div>
        </>
    )
    const resolutionAlign = (
        <>
            <p>{item?.attr?.resolutionAlign == RESOLUTION_ALIGN.INPUT ? '按上传图比例生成' : '按参考图比例生成'}</p>
        </>
    )
    const poseImg = (
        <>
            <p>姿势参考图</p>
            <img src={Utils.getImgThumbnail(item?.attr?.pose?.url)} alt="" />
        </>
    )
    const modelImg = (
        item?.attr?.person?.url && <>
            <p>模特参考图</p>
            {!item?.keepPose && <img src={Utils.getImgThumbnail(item?.attr?.person?.url)} alt="" />}
        </>
    )

    const bkgImg = (
        item?.attr?.background?.url && <>
            <p>背景参考图</p>
            {!item?.keepPose && <img src={Utils.getImgThumbnail(item?.attr?.background?.url)} alt="" />}
        </>
    )
    const matchImg = (
        item?.inputImages?.filter((i) => !i.mainImage)?.[0]?.url && <>
            <p>搭配参考图</p>
            <div className={styles.inputImg}>
                <img src={Utils.getImgThumbnail(item?.inputImages?.filter((i) => !i.mainImage)?.[0]?.url)} alt="" />
            </div>
        </>
    )
    const inputCloth = (
        item?.attr?.inputCloth && <>
            <p style={{ marginTop: '12px' }}>同款不同色平铺图</p>
            <img src={Utils.getImgThumbnail(item?.attr?.inputCloth)} alt="" />
        </>
    )
    const matchCloth = (
        item?.attr?.matchCloth && <>
            <p style={{ marginTop: '12px' }}>搭配图</p>
            <img src={Utils.getImgThumbnail(item?.attr?.matchCloth)} alt="" />
        </>
    )
    // 堆叠辅品图
    const refListImg = (
        item?.attr?.refList?.[0]?.url && <>
            <p>辅品图</p>
            <div className={styles.refListImg}>
                <div className={styles.refListImgFirst}>
                    {<img src={Utils.getImgThumbnail(item?.attr?.refList?.[0]?.url)} alt="" />}
                    <p className={styles.imgNum}>数量{item?.attr?.refList?.[0]?.num}</p>
                </div>
                {item?.attr?.refList?.[1]?.url &&
                    <div className={styles.refListImgItem} style={{ cursor: 'pointer' }} onClick={() => refListModalRef?.current?.open(item?.attr?.refList)}>
                        <img src={Utils.getImgThumbnail(item?.attr?.refList?.[1]?.url)} alt="" />
                        <span>+{item?.attr?.refList?.length || 1}</span>
                    </div>}
            </div>

        </>
    )
    // 智能详情页图
    const smartInputImgs = (
        item?.inputImages?.[0]?.url && <>
            <p>详情页图片</p>
            <div className={styles.refListImg}>
                <div className={styles.refListImgFirst}>
                    {<img src={Utils.getImgThumbnail(item?.inputImages?.[0]?.url)} alt="" />}
                </div>
                {item?.inputImages?.[1]?.url &&
                    <div className={styles.refListImgItem} style={{ cursor: 'pointer' }} onClick={() => refListModalRef?.current?.open(item?.inputImages)}>
                        <img src={Utils.getImgThumbnail(item?.inputImages?.[1]?.url)} alt="" />
                        <span>+{item?.inputImages?.length || 1}</span>
                    </div>}
            </div>
        </>
    )

    // 搭配上身图
    const matchImages = (
        item?.inputImages && <>
            <p>搭配图</p>
            <div className={styles.refListImg}>
                <div className={styles.refListImgFirst}>
                    <img src={Utils.getImgThumbnail(item?.inputImages?.[0]?.url)}
                        style={{ cursor: 'pointer' }}
                        onClick={() => setSelectedInputImg(item?.inputImages?.[0]?.url)} alt="" />
                </div>
                {item?.inputImages?.length > 1 &&
                    <div className={styles.refListImgItem} style={{ cursor: 'pointer' }} onClick={() => refListModalRef?.current?.open(item?.inputImages)}>
                        <img src={Utils.getImgThumbnail(item?.inputImages?.[2]?.url)} alt="" />
                        <span>+{item?.inputImages?.length || 1}</span>
                    </div>}
            </div>
        </>
    )

    // 提示词
    const promptTextRef = useRef(null)
    const [promptOverflow, setPromptOverflow] = useState(false)
    const [promptPopoverOpen, setPromptPopoverOpen] = useState(false)
    const promptText = useMemo(() => {
        return item?.attr?.prompt
    }, [item])
    useEffect(() => {
        const el = promptTextRef.current
        if (!el) return
        setPromptOverflow(el.scrollHeight > el.clientHeight + 1)
    }, [promptText])
    const prompt = (
        <div className={styles.promptWrap}>
            <div className={styles.promptTextWrap}>
                <p>描述：</p>
                <span ref={promptTextRef} className={styles.promptText}>{promptText}</span>
                {promptOverflow && (
                    <Popover
                        open={promptPopoverOpen}
                        onOpenChange={setPromptPopoverOpen}
                        trigger="hover"
                        placement="bottom"
                        content={<div className={styles.promptPopoverContent}>{promptText}</div>}
                    >
                        <span className={styles.viewAll}>查看全部</span>
                    </Popover>
                )}
            </div>
        </div>
    )



    const showConent = (
        item?.projectType == BATCH_IMAGES_TYPE.TRYON_BATCH ? (
            <>
                {title}
                {mode}
                {inputImg}
                {poseImg}
                {modelImg}
                {matchImg}
            </>
        ) : item?.projectType == BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ?
            (
                <>
                    {title}
                    {skinRefine}
                    {relight}
                    {item?.attr?.relight > 0 && relightMode}
                    {inputImg}
                    {modelImg}
                </>
            ) : item?.projectType == BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ?
                (
                    <>
                        {title}
                        {relight}
                        {item?.attr?.relight > 0 && relightMode}
                        {customBkgMode}
                        {resolutionAlign}
                        {inputImg}
                        {bkgImg}
                    </>
                ) : item?.projectType == BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH ?
                    (
                        <>
                            {title}
                            {inputImg}
                            {refListImg}
                        </>
                    ) : item?.projectType == BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH ?
                        (
                            <>
                                {title}
                                {inputImg}
                                {modelImg}
                                {inputCloth}
                                {matchCloth}
                            </>
                        ) : item?.projectType == BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH ||
                            item?.projectType == BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH ?
                            (
                                <>
                                    {title}
                                    {inputImg}
                                </>
                            ) : item?.projectType == BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH ?
                                (
                                    <>
                                        {title}
                                        {commodityColor}
                                        {commodityCategory}
                                        {commodityTemplate}
                                        {smartInputImgs}
                                    </>
                                ) : item?.projectType == BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH ?
                                    (
                                        <>
                                            {title}
                                            {matchImages}
                                            {modelImg}
                                            {prompt}
                                        </>
                                    ) : null
    )


    return (
        <>
            <div className={`${styles.ModelLeftCom} _beauty_scrollbar`}>
                {showConent}
            </div>
            <RefListModal ref={refListModalRef} onSelect={setSelectedInputImg} />
        </>

    )
}

export default ModelLeftCom